import { render } from "./form-sms-secure.vue?vue&type=template&id=d20a17ce"
import script from "./form-sms-secure.js?vue&type=script&lang=js&external"
export * from "./form-sms-secure.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__